import { render, staticRenderFns } from "./AttPermissions.vue?vue&type=template&id=168cba36&"
import script from "./AttPermissions.vue?vue&type=script&lang=js&"
export * from "./AttPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports